var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLadder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60",
    "data-name": "Layer 60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.14,3H44.58a1,1,0,0,0-1,1V6.38H20.42V4a1,1,0,0,0-1-1H15.86a1,1,0,0,0-1,1V60a1,1,0,0,0,1,1h3.56a1,1,0,0,0,1-1V54.38H43.58V60a1,1,0,0,0,1,1h3.56a1,1,0,0,0,1-1V4A1,1,0,0,0,48.14,3ZM43.58,35H20.42v-.59H43.58Zm0,2V41.1H20.42V37ZM20.42,32.42V28.33H43.58v4.09Zm23.16-6.09H20.42v-.59H43.58ZM20.42,23.74V19.65H43.58v4.09Zm23.16-6.09H20.42v-.59H43.58ZM20.42,43.1H43.58v.59H20.42Zm23.16-28H20.42V11H43.58ZM20.42,45.69H43.58v4.09H20.42ZM43.58,8.38V9H20.42V8.38ZM16.86,5h1.56V59H16.86Zm3.56,47.38v-.6H43.58v.6ZM47.14,59H45.58V5h1.56Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadder);
export default __webpack_public_path__ + "static/media/ladder.95835381cf5c430eba1d5378b6dd9b49.svg";
export { ForwardRef as ReactComponent };